import { projectImage } from "../../../../src/utils/cdn";
import * as React from 'react';
export default {
  projectImage,
  React
};